<script setup lang="ts">
import { ActionButton, Dialog, StatusTag } from '@taler/ui'
import { useI18n } from 'vue-i18n'

defineProps<{
  open: boolean
  label: string
  isSubmitting: boolean
  hasError: boolean
}>()

const emit = defineEmits<{ confirm: []; close: [] }>()

const { t } = useI18n()
</script>

<template>
  <Dialog :open="open" :label="t('accounts.archiveConfirmPrompt')" @close="emit('close')">
    <div class="flex flex-col gap-[var(--space-group)] p-[var(--space-block)]">
      <p class="text-[length:var(--text-step-4)] font-semibold text-[color:var(--color-text)]">
        {{ t('accounts.archiveConfirmPrompt') }}
      </p>
      <p class="text-[length:var(--text-step-2)] text-[color:var(--color-text-muted)]">{{ label }}</p>
      <StatusTag v-if="hasError" tone="danger" role="alert">{{ t('accounts.archiveFailed') }}</StatusTag>
      <div class="flex justify-end gap-[var(--space-inline)]">
        <button
          type="button"
          class="min-h-[var(--density-target-min)] rounded-[var(--radius-control)] border border-[color:var(--color-border-control)] px-[var(--space-group)] text-[color:var(--color-text)]"
          @click="emit('close')"
        >
          {{ t('accounts.cancel') }}
        </button>
        <ActionButton type="button" :disabled="isSubmitting" @click="emit('confirm')">
          {{ t('accounts.confirm') }}
        </ActionButton>
      </div>
    </div>
  </Dialog>
</template>
